import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { FormControl } from '@angular/forms';
import { cloneDeep } from 'lodash';
import { Subject } from 'rxjs';
import { SnotifyService } from 'ng-snotify';
import { Config } from '../config/config';
import { SharedDataService } from '../service/shared-data.service';
import { RestDataService } from '../service/rest-data.service';
import { StaticViewDataService } from '../service/static-view-data-service.service';
import { StaticDataService } from '../service/static-data.service';

@Component({
  selector: 'app-notification-center-page',
  templateUrl: './notification-center-page.component.html',
  styleUrls: ['./notification-center-page.component.scss']
})
export class NotificationCenterPageComponent implements OnInit {
  hourColumn =[];
  showNotification= true;
  hour =[];
  dateColumn = [
  ];
  notificationListArray=[];
  selectedTab: any = 'last24hours';
  mainSelectedTab: string = 'contentAnalytics';
  summary: any = {  
    "totalStoriesPublished": Number,
    "textStoriesPublished": Number,
    "photoGalleryStoriesPublished": Number,
    "videosStoriesPublished": Number,
    "webStoriesPublished": Number,
    "totalStoriesNotified": Number, 
    "webStoriesNotified": Number,
    "androidStoriesNotified": Number,
    "iosStoriesNotified": Number,
    "storiesWithAutoBacklink": Number,
    "storiesWithCheckedPlagiarism": Number,
    "premiumStories": Number
  }
  flag = false;
  flagfor30 = false;
  data: any;
  userDataResponse: any;
  notificationDataResponse: any;
  tempQuickRead: any;
  quickReadMax: any;
  savingQuickReadInProgress: boolean;
  quickReadSrc: string;
  summaryStatus:string;
  viewParagraph = [];
  userRestrictedSections: any = [];
  userRestrictedStoryTypes: any = [];
  maxPlagiarism: number;
  enableAndDisableSectionHourTable: boolean;
  enableAndDisableUserHourTable: boolean;
  enableNotificationHourPivot: boolean;
  enableAndDisableSectionDateTable: boolean;
  enableAndDisableUserDateTable: boolean;
  enableAndDisableNotificationDateTable: boolean;
  placeholder: string;
  arrowkeyLocation = 0;
  viewObject: { view_id: string; name: string; socketCodes: number[]; subPages: any[]; urls: { listing: string; meta: string; wireGet: string; wirePut: string; suggestion: string; }; fields: string; sortBy: string; apiEndPoints: { api_id: string; name: string; url: string; }[]; headers: ({ header_id: string; name: string; model_id: string; class: string; type: string; } | { header_id: string; name: string; class: string; type: string; model_id?: undefined; })[]; filters: { filter_id: string; name: string; facet_name_meta: string; facet_name: string; type: string; }[]; };
  notificationListUrl: string;
  valueChangeEvent: boolean;
  metaDataUrlNotification: string;
  showLoader = true;
  indexData: number;
  getDailySummaryUrl: string;
  getSummaryUrl: string;
  @Input()
  set byAuthor(byAuthor_string: string) {
    this.by_Author = (byAuthor_string && byAuthor_string.trim()) ? byAuthor_string : null;
  }
  by_Author;
  hideListing = false;
  getDataUrl = '';
  getDataDailyUrl = '';
  metaDataUrl = '';
  @ViewChild('listingInput', {static: false}) searchInput: ElementRef;
  socketsAllowed = [];
  filterList = [];
  facets = null;
  notificationFacets = null;
  userFacets = null;
  pageNum = 0;
  listArray = [];
  listIdArray = [];
  noresults = false;
  searchQuery: FormControl = new FormControl();
  pageSize = 50;
  pageSizeArray = [50, 100, 150, 200];
  sortByValueOf = null;
  exactMatch = false;
  filterUrl = {};
  fields = '';
  initialUrl = '';
  latestUrl = '';
  suggestionDataUrl = '';
  callFail = false;
  pages = 0;
  totalRecords = 0;
  listSuggestionArray = [];
  showSuggestionBox = false;
  str = '';
  searchFocus = false;
  showMore = false;
  headerList = [];
  getKeysArray=[];
  getKeysArrayfor30days;
  private subject: Subject<string> = new Subject();
  userKeyArray=[];
  notificationKeyArray=[];
  userDailyArray;
  userData = [];
  monthNames = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  @ViewChildren('listData2') listData: ElementRef;
  timings = {
    constr: 0,
    onin: 0,
    resp: 0,
    list: 0,
    getEnv: 0,
    getMeta: 0
  };
  domainConfig = null;
  showMy = false;
  getUserHourlyUrl: string;
  getUserDailyUrl: string;
  getNotificationHourlyUrl: string;
  getNotificationDailyUrl: string
  constructor(
    private config: Config,
    private sharedService: SharedDataService,
    private restService: RestDataService,
    private snotify: SnotifyService,
  ) {
  
  }


  ngOnInit() {
    this.getMetaData();
    this.viewObject = StaticViewDataService.Notification_Center_Listing_View;
    this.headerList = this.viewObject.headers;
    this.placeholder = 'Search...';
    this.notificationListUrl = this.config.get('product').baseUrl + this.viewObject.urls.listing;
      const filters = StaticViewDataService.Notification_Center_Listing_View.filters;
      this.filterList = this.sharedService.getUpdatedFilters(filters);
      let pageNum = 0;
      let url = this.notificationListUrl + '?page=' + pageNum + '&size=' + this.pageSize +'&sort=updateDate,desc&'+'fields=true,'+'storyId,eventFrom,topic,updateDate&search=';
      this.restService.http_get(url).subscribe(data => {
        if(data.content.length>0){
          this.notificationListArray = data.content;
          this.noresults = false
        } else{
          this.noresults = true
        }
        this.pages = data['totalPages'] > 20 ? 20 : data['totalPages'];
        this.totalRecords = data.totalElements;
    }, error=>{
      this.snotify.error('Failed to fetch notification list', '', this.sharedService.getConfig(false));
    });
  }

  arrayOne(n: number) {
    return Array(n);
  }

  callToggles(ev, model) {
    const key = ev.keyCode || ev.charCode;
    if (key === 13) {
      ev.preventDefault();
      this.toggleSwitch(model);
      ev.stopPropagation();
    }
  }

  getMetaData() {
    this.metaDataUrlNotification = this.config.get('product').baseUrl + StaticViewDataService.Notification_Center_Listing_View.urls.meta;
    if (this.metaDataUrlNotification && this.metaDataUrlNotification.trim() !== '') {
     this.restService.http_get(this.metaDataUrlNotification)
       .subscribe(data => {
         this.notificationFacets = { ...data, ...this.notificationFacets };
         this.facets = this.notificationFacets;
       });
    }
  }


  getFilterData(facet_name) {
    if (this.facets && this.facets[facet_name]) {
      if(facet_name==='topics') {
        let fact = {};
        this.facets[facet_name].forEach(e=>{
            fact[e] = e;
        });
        return fact;
      } else {
        return this.facets[facet_name];
      }
    } else {
      return null;
    }
  }

  urlNotificationUpdate(ev) {
    this.filterUrl[ev.type] = ev.data;
    this.pageNum = 0;
    this.notificationSearchResults(this.str, this.pageNum, this.notificationDataInsertion);
  }

  topFunction() {
    document.body.scrollTop = 0; // For Safari
    if (document.getElementsByClassName('contentList') && document.getElementsByClassName('contentList').length > 0) {
      document.getElementsByClassName('contentList')[0].scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
  }

  measureTime(count) {
    if (this.listData['length'] === this.pageSize) {
      this.timings.list = performance.now();
    } else if (count < 6) {
      setTimeout(e => {
        this.measureTime(++count);
      }, 0);
    }
  }
  onPageNumberChange(pagenum) {
    this.pageNum = pagenum;
    this.searchNotificationResults(this.str, this.pageNum, this.notificationDataInsertion);
  }

  onKeydown(event, input) {
    if (event.key === 'Enter') {
      this.getsearchResults(this.str);
      this.showSuggestionBox = false;
    } else if (event.keyCode === 32) {
      this.getautoSuggestion(this.str, data => {
        this.listSuggestionArray = [];
        const dataSuggestion = data;
        if (dataSuggestion.length > 0) {
          for (let i = 0; i < dataSuggestion.length; i++) {
            this.listSuggestionArray.push(dataSuggestion[i]);
          }
          this.showSuggestionBox = true;
        } else {
          this.showSuggestionBox = false;
        }
      });
    } else if (event.keyCode === 40 && this.arrowkeyLocation < this.listSuggestionArray.length - 1) {
      this.valueChangeEvent = false;
      this.showSuggestionBox = true;
      this.arrowkeyLocation++;
      this.str = this.listSuggestionArray[this.arrowkeyLocation];
    } else if (event.keyCode === 38 && this.arrowkeyLocation > 0) {
      this.valueChangeEvent = false;
      this.showSuggestionBox = true;
      this.arrowkeyLocation--;
      this.str = this.listSuggestionArray[this.arrowkeyLocation];
    } else {
      this.subject.next(input.value);
      this.valueChangeEvent = true;
      this.arrowkeyLocation = 0;
    }
    return true;
  }

  getautoSuggestion(query, callback) {
    if (query && query.trim() !== '') {
      const tempQuery = query;
      query = query.split(' ');
      query = query[(query.length - 1)];
      if (query.length > 2 && this.valueChangeEvent) {
        this.showSuggestionBox = false;
        const url = this.suggestionDataUrl + '?text=' + StaticDataService.encodeSpecialChar(tempQuery);
        this.restService.http_get(url)
          .subscribe(data => {
            callback(data);
          },
            error => {
            });
      }
    } else {
      this.getNotificationDefaultList(0, this.notificationDataInsertion);
      this.showSuggestionBox = false;
    }
  }
  toggleSwitch(model) {
    if (model === 'exact') {
      this.exactMatch = !this.exactMatch;
      this.notificationSearchResults(this.str, this.pageNum, this.notificationDataInsertion);
    }
  }

  notificationSearchResults(query, pageNum, callback) {
    this.getNotificationDefaultList(pageNum, data => {
      callback(data);
    });
}

  getsearchResults(item) {
    this.searchNotificationResults(item, 0, data => {
      this.str = item;
      this.pageNum = 0;
      this.notificationDataInsertion(data);
      if (data['content'].length > 0) {
        this.showSuggestionBox = false;
        this.valueChangeEvent = false;
      } else {
        this.showSuggestionBox = true;
        this.valueChangeEvent = true;
      }
    });
  }

  searchNotificationResults(query, pageNum, callback) {
    if (query && query.trim() !== '') {
      let url = this.notificationListUrl + '?page=' + pageNum + '&size=' + this.pageSize + '&sort=updateDate,desc';
      if (this.sortByValueOf) {
        url += '&sort=' + this.sortByValueOf + ',desc';
      }
      url += this.fields;
      if (this.exactMatch) {
        url += '&exact=true';
      }
      url += '&search=';
      if (this.by_Author) {
        url += ',readByUsers:' + this.by_Author;
      }
      if(this.userRestrictedSections && this.userRestrictedSections.length > 0) {
        console.log(this.userRestrictedSections)
        url += ',metadata.section:'
        for(let sec of this.userRestrictedSections) {
          url += sec + (this.userRestrictedSections.length > 1 ? ';' : '');
        }
      }
      if(this.userRestrictedStoryTypes && this.userRestrictedStoryTypes.length > 0) {
        url += ',type:'
        for(let sec of this.userRestrictedStoryTypes) {
          url += sec + (this.userRestrictedStoryTypes.length > 1 ? ';' : '');
        }
     }
      if (this.filterUrl) {
        for (const filter in this.filterUrl) {
          if (filter) {
            url += this.filterUrl[filter];
          }
        }
      }
      const querArr = query.split(':');
      if (querArr && querArr.length > 1 && querArr[0].toUpperCase() === 'ID') {
        url += ',id:' + querArr[1].trim();
      } else {
        url += ',topic~' + StaticDataService.encodeSpecialChar(query);
      }
      this.callFail = false;
      this.latestUrl = url;
      this.timings['firstGet'] = performance.now();
      this.restService.http_get(url)
        .subscribe(data => {
          this.timings.resp = performance.now();
          if(data.content.length>0){
            this.notificationListArray = data.content;
            this.noresults = false
          } else{
            this.noresults = true
          }
          console.log('response received => ', performance.now() - this.timings['firstGet']);
          this.pages = data['totalPages'] > 20 ? 20 : data['totalPages'];
          this.totalRecords = data['totalElements'];
          this.topFunction();
          this.callFail = false;
          this.measureTime(0);
          callback(data);
        },
          error => {
            this.callFail = true;
          });
    } else {
      this.getNotificationDefaultList(pageNum, data => {
        callback(data);
      });
    }
  }

  getNotificationDefaultList(pageNum, callback) {
    let url = this.notificationListUrl + '?page=' + pageNum + '&size=' + this.pageSize + '&sort=updateDate,desc';
    if (this.sortByValueOf) {
      url += '&sort=' + this.sortByValueOf + ',desc';
    }
    url += this.fields;
    if (this.exactMatch) {
      url += '&exact=true';
    }
    url += '&search=';
    if (this.filterUrl) {
      for (const filter in this.filterUrl) {
        if (filter) {
          url += this.filterUrl[filter];
        }
      }
    }
    this.callFail = false;
    if (this.initialUrl === '') {
      this.initialUrl = url;
    }
    this.latestUrl = url;

    this.timings['firstGet'] = performance.now();
    this.restService.http_get(url)
      .subscribe(data => {
        this.timings.resp = performance.now();
         if(data.content.length>0){
          this.notificationListArray = data.content;
          this.noresults = false
        } else{
          this.noresults = true
        }
        this.pages = data['totalPages'] > 20 ? 20 : data['totalPages'];
        this.totalRecords = data['totalElements'];
        this.callFail = false;
        this.topFunction();
        this.measureTime(0);
        callback(data);
      });
  }

  notificationDataInsertion = (data) => {
    const results = data;
  }

  openStory(item) {
    let domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    setTimeout(e2 => {
      window.open(window.location.origin + '/dash/story/' + item + '&domain=' + domainId, "_blank");
    }, 70);
  }

  getNewTypeDate(datestring) {
    if (datestring) {
      if (typeof datestring === 'string') {
        const dt = new Date(datestring.replace('+0000', 'Z'));
        return this.getFullDate(Math.round(dt.getTime()));
      } else {
        return this.getFullDate(datestring);
      }
    } else {
      return 'not present';
    }
  }

  getFullDate(seconds) {
    if (seconds) {
      const date = new Date(seconds);
      return '' + this.monthNames[date.getMonth()] + ' ' + date.getDate() + ', ' + ' ' + date.getFullYear() + ', ' +
        ((date.getHours() < 10) ? '0' + date.getHours() : date.getHours()) + ':'
        + ((date.getMinutes() < 10) ? '0' + date.getMinutes() : date.getMinutes());
    } else {
      return 'not present';
    }
  }

  onPageSizeChange(size) {
    this.pageNum = 0;
    this.pageSize = size;
    this.searchNotificationResults(this.str, this.pageNum, this.notificationDataInsertion);

  }
}
